import { Farm, SaveFarm } from '@agroone/entities'
import { ActionCreator, createAction, props, Action } from '@ngrx/store'

export enum FarmActionTypes {
  LOAD_FARMS = '[Farm] Load Farms',
  LOAD_FARMS_SUCCESS = '[Farm] Load Farms Success',
  LOAD_FARMS_FAILURE = '[Farm] Load Farms Failure',
  ADD_FARM = '[Farm] Add Farm',
  ADD_FARM_SUCCESS = '[Farm] Add Farm Success',
  ADD_FARM_FAILURE = '[Farm] Add Farm Failure',
  UPDATE_FARM = '[Farm] Update Farm',
  UPDATE_FARM_SUCCESS = '[Farm] Update Farm Success',
  UPDATE_FARM_FAILURE = '[Farm] Update Farm Failure',
  CLEAR_FARM = '[Farm] Clear Farm',
}

// LOAD FARMS
export const loadFarms: ActionCreator<FarmActionTypes.LOAD_FARMS, () => Action<FarmActionTypes.LOAD_FARMS>> =
  createAction(FarmActionTypes.LOAD_FARMS)
export const loadFarmsSuccess: ActionCreator<
  FarmActionTypes.LOAD_FARMS_SUCCESS,
  (props: { farms: Farm[] }) => {
    farms: Farm[]
  } & Action<FarmActionTypes.LOAD_FARMS_SUCCESS>
> = createAction(FarmActionTypes.LOAD_FARMS_SUCCESS, props<{ farms: Farm[] }>())
export const loadFarmsFailure: ActionCreator<
  FarmActionTypes.LOAD_FARMS_FAILURE,
  (props: { error: unknown }) => {
    error: unknown
  } & Action<FarmActionTypes.LOAD_FARMS_FAILURE>
> = createAction(FarmActionTypes.LOAD_FARMS_FAILURE, props<{ error: unknown }>())

// ADD FARM
export const addFarm: ActionCreator<
  FarmActionTypes.ADD_FARM,
  (props: {
    payload: {
      farm: SaveFarm
      options?: {
        [key: string]: unknown
      }
    }
  }) => {
    payload: {
      farm: SaveFarm
      options?: {
        [key: string]: unknown
      }
    }
  } & Action<FarmActionTypes.ADD_FARM>
> = createAction(
  FarmActionTypes.ADD_FARM,
  props<{
    payload: { farm: SaveFarm; options?: { [key: string]: unknown } }
  }>(),
)
export const addFarmSuccess: ActionCreator<
  FarmActionTypes.ADD_FARM_SUCCESS,
  (props: {
    payload: {
      farm: Farm
    }
  }) => {
    payload: {
      farm: Farm
    }
  } & Action<FarmActionTypes.ADD_FARM_SUCCESS>
> = createAction(FarmActionTypes.ADD_FARM_SUCCESS, props<{ payload: { farm: Farm } }>())
export const addFarmFailure: ActionCreator<
  FarmActionTypes.ADD_FARM_FAILURE,
  (props: { error: unknown }) => {
    error: unknown
  } & Action<FarmActionTypes.ADD_FARM_FAILURE>
> = createAction(FarmActionTypes.ADD_FARM_FAILURE, props<{ error: unknown }>())

// UPDATE FARM
export const updateFarm: ActionCreator<
  FarmActionTypes.UPDATE_FARM,
  (props: {
    payload: {
      farm: SaveFarm
    }
  }) => {
    payload: {
      farm: SaveFarm
    }
  } & Action<FarmActionTypes.UPDATE_FARM>
> = createAction(FarmActionTypes.UPDATE_FARM, props<{ payload: { farm: SaveFarm } }>())
export const updateFarmSuccess: ActionCreator<
  FarmActionTypes.UPDATE_FARM_SUCCESS,
  (props: {
    payload: {
      farm: Farm
      message?: string
      loading: boolean
    }
  }) => {
    payload: {
      farm: Farm
      message?: string
      loading: boolean
    }
  } & Action<FarmActionTypes.UPDATE_FARM_SUCCESS>
> = createAction(
  FarmActionTypes.UPDATE_FARM_SUCCESS,
  props<{ payload: { farm: Farm; message?: string; loading: boolean } }>(),
)
export const updateFarmFailure: ActionCreator<
  FarmActionTypes.UPDATE_FARM_FAILURE,
  (props: { error: unknown; loading: boolean }) => {
    error: unknown
    loading: boolean
  } & Action<FarmActionTypes.UPDATE_FARM_FAILURE>
> = createAction(FarmActionTypes.UPDATE_FARM_FAILURE, props<{ error: unknown; loading: boolean }>())
export const clearFarms: ActionCreator<FarmActionTypes.CLEAR_FARM, () => Action<FarmActionTypes.CLEAR_FARM>> =
  createAction(FarmActionTypes.CLEAR_FARM)
